import Constants from '../../constants';

const { Vendor } = Constants;

const setVendor = (vendor) => ({
  type: Vendor.SET_VENDOR,
  vendor,
});

export default {
  setVendor,
};
